import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import { Text } from "@/components/typography";
import styles from "./ui.module.css";

export interface AlertProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  children?: ReactNode;
  tone?: "info" | "success" | "warning" | "danger";
}

export function Alert({
  title,
  children,
  className,
  tone = "info",
  ...rest
}: AlertProps) {
  return (
    <div
      role="status"
      className={cn(
        styles.alert,
        tone === "info" && styles.alertInfo,
        tone === "success" && styles.alertSuccess,
        tone === "warning" && styles.alertWarning,
        tone === "danger" && styles.alertDanger,
        className,
      )}
      {...rest}
    >
      <div>
        {title ? (
          <Text role="bodyStrong" as="div">
            {title}
          </Text>
        ) : null}
        {children ? (
          <Text role="small" color="secondary" as="div">
            {children}
          </Text>
        ) : null}
      </div>
    </div>
  );
}
